var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValidationExclamation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2,
  height: 9
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M.43 4.696.26 2.153A19 19 0 0 1 .21 1.085q0-.441.231-.687A.8.8 0 0 1 1.05.15q.457 0 .611.316.154.315.154.91 0 .35-.037.712L1.55 4.707q-.037.466-.16.717a.42.42 0 0 1-.403.25q-.287 0-.399-.242Q.477 5.19.43 4.696m.589 3.494a.84.84 0 0 1-.566-.21q-.242-.21-.242-.586 0-.33.231-.56a.77.77 0 0 1 .566-.231q.335 0 .57.23.237.232.237.56 0 .373-.239.585a.8.8 0 0 1-.557.212"
})));
export { SvgValidationExclamation as ReactComponent };
export default __webpack_public_path__ + "static/media/validation-exclamation.a5294b27.svg";